import { SchemaAttributes, SchemaGeneral, SchemaGroups } from '@/Data/typesV2'
import { getSchema } from '@/utils/getSchema'
import {
  getLocalizedSchemaAttributes,
  getLocalizedSchemaGeneral,
  getLocalizedSchemaGroups,
} from '@/utils/schemaLocalization'

export const getSchemaAttributes = (name: string) => {
  const { schema } = getSchema(name)

  const schemaGroups = getLocalizedSchemaGroups(
    schema?.get('groups') as SchemaGroups,
  ) as SchemaGroups

  const schemaGeneral = getLocalizedSchemaGeneral(
    schema?.get('general') as SchemaGeneral,
  ) as SchemaGeneral
  const groupsOrder = schemaGeneral?.groupOrder
  const schemaAttributes = getLocalizedSchemaAttributes(
    schema?.get('attributes') as SchemaAttributes,
  ) as SchemaAttributes

  return {
    schema,
    schemaGroups,
    schemaGeneral,
    groupsOrder,
    schemaAttributes,
  }
}

export {
  getVisibleAttributes,
  isAttributeVisible,
} from './getVisibleAttributes'
